module.exports = __webpack_public_path__ + "static/media/clock.44a11329.png";